<!--隐私政策-->
<template>
    <div style="padding:10px 10px 10px 10px">
        <h1 style="text-align: center">《爱奇艺联盟媒体服务平台隐私政策》</h1>
        <p style="text-align: right">本版上线时间：2023年3月28日</p>
        <p style="text-align: right">本版生效时间：2023年4月4日</p>
        <h3>导言</h3>
        <p>作为爱奇艺联盟媒体平台的服务提供方，北京爱奇艺科技有限公司及/或其关联公司（以下简称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息。 我们希望通过本《爱奇艺联盟媒体服务平台隐私政策》（以下也称“本政策”）向您清晰地介绍您（即：“开发者”）和您的最终用户（即：“您的产品的最终用户”或“您的产品的终端用户”）在使用我们的爱奇艺联盟媒体服务平台提供的产品与/或服务（以下简称“我们的服务”或“爱奇艺联盟服务”）时，我们如何处理您的个人信息，以及我们提供的管理、保护这些信息的方式。</p>
        <p>爱奇艺联盟服务，包括但不限于其网站、SDK、API、工具以及不断创新研发的产品与/或服务，均适用于本政策。但需要特别说明的是，第三方作为独立的个人信息处理者展示、链接或者再封装我们的服务，并向您提供<b>其产品与/或服务的，相关信息处理由第三方独立决定，我们无法了解或控制其处理目的、方式、范围等，</b>因此，请您在仔细阅读并理解其隐私政策后，再决定是否使用其产品与/或服务。</p>
        <p><b>涉及本政策中与您的权益（可能）存在重大关系的条款以及涉及敏感个人信息（如有）的处理，我们已经以字体加粗、下划线或其他合理方式提示您重点阅读。</b>如您在阅读本政策过程中有任何疑惑的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您作出解答。</p>
        <br>
        <h3><b>本政策将帮助您了解以下内容</b></h3>
        <ul>
          <li>一、 我们如何收集和使用您的个人信息</li>
          <li>二、 我们如何使用Cookie和同类技术</li>
          <li>三、 我们如何共享、转让、公开披露您的个人信息</li>
          <li>四、 您对您的个人信息享有的控制权</li>
          <li>五、 我们如何存储和保护您的个人信息</li>
          <li>六、 未成年人保护</li>
          <li>七、 本政策的更新</li>
          <li>八、 如何联系我们</li>
          <li>九、 其他</li>
        </ul>
        <br>
        <h3>一、	我们如何收集和使用您的个人信息</h3>
        <p>在您使用爱奇艺联盟服务的过程中，我们根据合法、正当、必要的原则收集和使用您的个人信息。</p>
        <p><b>我们主要通过以下途径收集您在使用我们产品与/或服务时涉及的个人信息：</b></p>
        <ul>
          <li>(一)	根据业务需要您主动提供的信息，例如：注册账号时提供的电子邮箱。</li>
          <li>(二)	我们收集、记录、汇总的信息，例如：您的设备信息。</li>
          <li>(三)	我们从第三方间接获取的您的信息，例如：我们的合作方在征得您授权同意后共享至我们的您的部分信息。</li>
        </ul>
        <p><b>通常情况下，我们会出于以下功能/场景的实现，收集和使用您的个人信息或申请相关权限：</b></p>
        <p>1.	注册、登录、使用爱奇艺联盟服务</p>
        <ul>
          <li>(1)	正式使用爱奇艺联盟服务前，您需要线下申请服务账号。账号申请需要您提供邮箱地址，我们会使用您的电子邮箱为您创建服务账号并提供<b>初始密码。</b></li>
          <li>(2)	在您登录爱奇艺联盟服务平台时，为了帮您顺利完成登录流程，您需要向我们提供您的<b>电子邮箱、账号密码信息。</b></li>
          <li>(3)	为与您达成合作，保证您正常使用我们的服务，我们会通过线上线下多方式收集您的如下信息：<b>公司名称、银行账户信息、应用名称、联系人姓名、联系电话、电子邮箱、联系地址，</b>并可能使用您的前述信息以预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、其他用户，或我们的合法权益。</li>
        </ul>
        <p>2.	您在使用爱奇艺联盟服务的过程中，为提供更灵活、更智能、更有效的个性化投放方案，有效提升最终用户粘性，提高App活跃度，我们通过收集<b>设备标识信息（如Mac地址/IMEI/AndroidID/Openudid/OAID/IDFA/IDFV）</b>对最终用户进行唯一标识，以便进行个性化推送。</p>
        <p>为实现特定广告服务功能，在您的产品中使用我们的SDK时，我们的SDK会获取您的产品的最终用户的个人信息以及申请相关权限：</p>
        <p>(1)	收集最终用户的个人信息种类及使用目的</p>
        <table width = 100% border="1" cellspacing="0">
          <tr>
            <td><b>SDK名称</b></td>
            <td><b>个人信息种类</b></td>
            <td><b>使用目的</b></td>
          </tr>
          <tr>
            <td rowspan="4">爱奇艺联盟SDK</td>
            <td>
              <p>设备信息</p>
              <p>【双端】设备品牌、型号、系统版本、Mac地址，设备语言、网络类型、WiFi名称、IP地址、电池容量、物理内存、硬盘容量、系统语言、运营商信息等基础信息</p>
              <p>【仅Android】CPU类型、IMEI、AndroidID</p>
              <p>【仅iOS】运营商信息、开机时间、系统更新时间、磁盘容量、CPU数量、内存容量、设备名称、地区名称、时区、OpenUdid、IDFV</p>
              <p>基于优化广告投放目的选择是否提供：</p>
              <p>【仅Android】OAID</p>
              <p>【仅iOS】IDFA</p>
            </td>
            <td>广告投放、监测归因、反作弊</td>
          </tr>
          <tr>
            <td>
              <p>应用信息：</p>
              <p>【仅Android】：应用名称、包名、版本号</p>
              <p>【仅iOS】：应用bundleId</p>
              <p>基于广告投放优化目的选择是否提供：</p>
              <p>【仅Android】应用列表信息</p>
            </td>
            <td>广告投放、反作弊</td>
          </tr>
          <tr>
            <td>
              <p>广告信息：</p>
              <p>【双端】如展示、点击、转化等广告交互数据</p>
            </td>
            <td>监测归因、广告投放统计分析、反作弊</td>
          </tr>
          <tr>
            <td>
              <p>位置信息</p>
              <p>基于广告投放优化目的选择是否提供：</p>
              <p>【双端】位置信息</p>
            </td>
            <td>广告定向投放、反作弊</td>
          </tr>
        </table>
        <p>(2)	申请最终用户的应用权限</p>
        <p>iOS端</p>
        <table width = 100% border="1" cellspacing="0">
          <tr>
            <td><b>权限名称</b></td>
            <td><b>是否必选</b></td>
            <td><b>使用目的</b></td>
          </tr>
          <tr>
            <td>
              <p>NSUserTrackingUsageDescription</p>
              <p>读取设备标识信息</p>
            </td>
            <td>非必选</td>
            <td>广告投放、监测归因、反作弊</td>
          </tr>
          <tr>
            <td>
              <p>NSLocationWhenInUseUsageDescription</p>
              <p>仅App被使用时获取地理位置</p>
            </td>
            <td>非必选</td>
            <td>广告定向投放、反作弊</td>
          </tr>
        </table>
      <p>Android端：</p>
      <table width = 100% border="1" cellspacing="0">
        <tr>
          <td><b>权限名称</b></td>
          <td><b>是否必选</b></td>
          <td><b>使用目的</b></td>
        </tr>
        <tr>
          <td>
            <p>INTERNET</p>
            <p>网络权限</p>
          </td>
          <td>必选</td>
          <td>进行网络连接</td>
        </tr>
        <tr>
          <td>
            <p>ACCESS_NETWORK_STATE</p>
            <p>获取网络状态权限</p>
          </td>
          <td>必选</td>
          <td>检查网络状态、广告投放、反作弊</td>
        </tr>
        <tr>
          <td>
            <p>REQUEST_INSTALL_PACKAGES</p>
            <p>安装应用权限</p>
          </td>
          <td>非必选</td>
          <td>广告主的应用安装</td>
        </tr>
        <tr>
          <td>
            <p>ACCESS_WIFI_STATE</p>
            <p>访问WiFi状态</p>
          </td>
          <td>非必选</td>
          <td>广告投放、监测归因、反作弊</td>
        </tr>
        <tr>
          <td>
            <p>READ_PHONE_STATE</p>
            <p>读取设备信息</p>
          </td>
          <td>非必选</td>
          <td>获取手机状态参数与设备标识等常用设备信息，用于广告投放、监测归因、反作弊</td>
        </tr>
        <tr>
          <td>
            <p>READ_EXTERNAL_STORAGE</p>
            <p>读取外置存储器</p>
          </td>
          <td>非必选</td>
          <td>应用下载、广告投放、广告素材存储</td>
        </tr>
        <tr>
          <td>
            <p>WRITE_EXTERNAL_STORAGE</p>
            <p>写入外置存储器</p>
          </td>
          <td>非必选</td>
          <td>应用下载、广告投放、广告素材存储</td>
        </tr>
        <tr>
          <td>
            <p>ACCESS_FINE_LOCATION</p>
            <p>ACCESS_COARSE_LOCATION</p>
            <p>访问精确/粗略地理位置</p>
          </td>
          <td>非必选</td>
          <td>广告定向投放、反作弊</td>
        </tr>
      </table>
      <p>3.	当您使用我们的服务的过程中，为了保证您账号的安全性、防止恶意程序和反作弊，我们可能会收集您的浏览器和计算机上的信息，包括但不限于您的<b>IP地址、浏览器类型、使用的语言、访问日期和时间、平台操作、使用、服务日志等信息</b>。若您使用移动网页端登录爱奇艺联盟服务平台，我们可能会读取移动设备相关信息，包括但不限于您的<b>设备型号、设备标识信息、操作系统、运营商信息等。</b></p>
      <p>4.	维护、改进我们的服务</p>
      <p>(1)	为实现问题、纠纷解决，记录相关问题的处理方案及结果，不断提升服务质量，我们可能需要收集您的如下个人信息：<b>联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）及与您需求相关联的其他必要信息。</b></p>
      <p>(2)	为确保运行正常与服务安全，最大程度减少应用崩溃，提高我们服务的可扩展性和性能，我们可能会收集<b>服务频率、总体安装、使用情况、性能数据、崩溃数据等信息。</b></p>
      <p>(3)	为评估、分析、改进我们的产品与/或服务，我们可能会收集我们可能收集您<b>在参与我们的活动、问卷调查等提供的相关信息、以及您与我们集团、合作方互动时，我们通过其间接收集的部分信息。</b></p>
      <p>5.	数据分析与统计</p>
      <p>我们可能使用合法收集的您或您的最终用户的相关信息进行研究、统计分析与预测。例如，可能将预测拥有共同偏好的最终用户进行人群分类，并提供群体标签、人群分群管理等服务，用于改善爱奇艺联盟服务，提升投放及营销决策效果。但请您放心，<b>我们会采用去标识化、匿名化的技术，且涉及我们使用机器学习或算法模型训练的，我们并不会识别特定自然人的真实身份。</b></p>
      <p>6.	其他</p>
      <p>如果某一需要收集您的个人信息的功能未能在本政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意</p>
      <br>
      <p><b><i>例外情形</i></b></p>
      <p>(1)	我们在以下情况下处理（包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等）您的个人信息无需您的授权同意：</p>
      <p>(2)	为订立、履行个人作为一方当事人的合同所必需；</p>
      <p>(3)	为履行法定职责或者法定义务所必需（包括与（可能的）诉讼、仲裁、执行等法律程序直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的）；</p>
      <p>(4)	为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
      <p>(5)	为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
      <p>(6)	依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
      <p>(7)	法律、行政法规规定的其他情形。</p>
      <br>
      <h3>二、	我们如何使用Cookie和同类技术</h3>
      <p>Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web Beacon、Proxy、嵌入式脚本等。</p>
      <p>目前， 我们可能会设置认证与保障安全性的Cookie或采用同类技术，帮助您省去重复注册信息步骤，提高登录和响应速度；确认您账号的安全性，防止遇到盗用、欺诈等不法行为。</p>
      <p>我们承诺，不会将Cookie 用于本政策所述目的之外的任何其他用途。</p>
      <br>
      <h3>三、	我们如何共享、转让、公开披露您的个人信息</h3>
      <p>(一)	共享</p>
      <p>我们在遵守“合法正当、最小必要、目的明确原则”的前提下共享您的个人信息。</p>
      <p>如我们委托第三方处理您的个人信息的，我们将会与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。如果我们与第三方个人信息处理者共同决定您个人信息的处理目的和处理方式的，将与合作商约定各自的权利和义务，且该约定不影响您向其中任何一个个人信息处理者要求行使您的权利，若侵害您的个人信息权益造成损害的，我们将依法承担连带责任。</p>
      <p>我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作商的信息保护义务与责任，与业务合作商在合作前签署关于数据安全的保护协议。</p>
      <p>1.	我们的合作商</p>
      <p>(1)	广告合作</p>
      <p>广告投放：我们可能会向广告主及/或其委托的投放代理商提供您的<b>去标识化的设备信息、群体标签</b>以向您推送更合适您的资讯、推广等商业性信息。</p>
      <p>广告建站：为提供更合适您更优质的服务，广告主及/或其委托的投放代理商会收集您在相关广告页面<b>主动填写的相关的个人信息（包括联系电话，具体以实际页面提供为准）。</b></p>
      <p>广告统计分析与优化：我们可能会向提供广告统计分析与优化服务的合作商提供您的<b>去标识化的设备信息、群体标签、广告曝光、浏览、点击、播放以及广告转化数据等广告相关数据，</b>用于分析、衡量广告和相关服务的有效性、进行广告或决策建议、提高广告有效触达率，更好的为您提供优质、适合您的服务；广告主及/或其委托的代理商可能要求我们提供前述部分或全部信息，用于进行用户来源的运营分析、优化广告投放策略或改进其产品与服务。</p>
      <p>(2)	我们接受尽职调查或审计时，与外部监管、专业咨询机构（如审计机构）等共享您的相关信息</p>
      <p>(3)	为提升相关领域的科研能力，促进科技发展水平，我们在确保个人信息安全与目的正当的前提下，可能会与合作的科研院所、高校等机构使用去标识化或匿名化的个人信息。</p>
      <p>(4)	其他为实现我们的服务/功能所必需进行的共享。</p>
      <p>2.	爱奇艺集团内部共享</p>
      <p>为便于我们向您提供一致化服务、完善个性化体验、实现安全风控、提供客户服务之需要，我们在符合法律法规要求的前提下，可能将部分您的信息在集团内部共享。</p>
      <p>(二)	转让</p>
      <p>转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外：</p>
      <p>1.	您自行提出要求，且符合法律法规及监管的相关规定条件的。</p>
      <p>2.	如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式，并要求接收方继续受本政策的约束。接收方变更原先的处理目的、处理方式的，我们将要求接收方重新取得您的同意。</p>
      <p>(三)	公开披露</p>
      <p>除符合法律法规的规定进行公开披露或获得您单独同意外，我们不会公开披露您未自行公开或者其他未合法公开的个人信息。且在我们公开披露您的个人信息前会进行个人信息保护影响评估，并采用符合行业内标准的安全保护措施进行处理。</p>
      <br>
      <h3>四、	您对个人信息享有的控制权</h3>
      <p>我们非常重视您作为个人信息主体所享有的权利，并尽全力保护您对您的个人信息的控制权（包括您对于您个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销账号、投诉举报等权利）。您可以按照本隐私政策公示的联系方式与我们联系，我们将协助您进行操作。</p>
      <br>
      <h3>五、	我们如何存储和保护您的个人信息</h3>
      <p>(一)	个人信息的存储</p>
      <p>1.	存储地点：我们在中华人民共和国境内运营中收集和产生的个人信息存储于中华人民共和国境内。</p>
      <p>2.	存储期限：我们在为提供我们的产品与/或服务之目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册/登录功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。</p>
      <p>在您主动删除个人信息、注销账号或超出必要的存储期限后，我们会对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>
      <p>我们判断个人信息的必要存储期限主要依据以下标准：（1）维护相应交易及业务记录，以应对您可能的查询或投诉；（2）保证我们为您提供服务的安全和质量；（3）您是否同意更长的留存期间。</p>
      <br>
      <p>(二)	个人信息的保护措施</p>
      <p>我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术及组织和管理等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。包括：</p>
      <p>(1)	采用多种安全技术措施对数据的收集、传输、存储、处理、销毁、审计等环节进行管控。</p>
      <p>(2)	建立个人信息安全保护组织，落实个人信息安全规范处理、信息安全宣贯与培训等措施。</p>
      <p>(3)	构建并完善包括安全体系认证、业务安全能力认证及网络安全等级保护认证的个人信息安全管理体系。</p>
      <p>(4)	建立安全应急响应体系、安全事件应急处理机制，及时、高效完成安全事件处理。</p>
      <p>请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息披露给他人等方式，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策文末中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。</p>
      <br>
      <h3>六、	未成年人保护</h3>
      <p>我们非常重视未成年人的个人信息保护，如果根据您提供的个人信息，明确判断您为未成年人的，您将无法继续享受我们的服务。若您的应用是针对未成年人开发的，请您确保未成年人使用（包括账号注册、协议同意、功能使用等）您的应用已经获得其监护人的有效授权同意。</p>
      <p>受制于现有技术和业务模式，我们很难主动识别未成年人信息，如果我们发现在未经监护人授权的情况下收集了未成年人的个人信息，会设法尽快删除相关信息；如果监护人发现存在未经授权而收集未成年人的个人信息情况，监护人可通知我们删除。</p>
      <br>
      <h3>七、	本政策的更新</h3>
      <p><b>我们鼓励您在使用我们的产品或服务前仔细查阅我们的《爱奇艺联盟媒体服务隐私政策》。</b>为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本政策的条款，该更新构成本政策的一部分。我们会通过平台网站通知或以其他适当方式提醒您更新内容，以便你及时了解本政策的最新版本。但未经您明确同意，我们不会减损或侵害您依据本政策享有的个人权益。</p>
      <br>
      <h3>八、	如何联系我们</h3>
      <p>如您对本政策的执行或对我们的隐私保护相关事宜有任何投诉、建议、疑问，您可通过以下方式联系我们，我们会在验证您的用户身份后的15个工作日内向您回复：</p>
      <p>1.	专设的邮件通道：为更好地保护您的权益，我们专门设立了privacy@qiyi.com邮箱，您可以通过该邮箱与我们联系</p>
      <p>2.	个人信息保护专员： 您可发送邮件至privacy@qiyi.com或写信至以下地址来与其联系：上海市长宁区临虹路365号爱奇艺创新大厦2层 法律部 个人信息保护专员（收）；邮编：200335；</p>
      <p>3.	在线客服/其他在线意见反馈通道：您可与我们平台上产品功能页面的在线客服联系或者在线提交意见反馈；</p>
      <p>4.	人工客服通道：您可以拨打我们的任何一部客服电话与我们联系。</p>
      <br>
      <h3>九、	其他</h3>
      <p>(一)	本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本政策的签订、履行等发生任何争议的，双方应尽量友好协商解决；协商不成时，任何一方均可向<b>被告住所地享有管辖权的人民法院</b>提起诉讼。</p>
      <p>(二)	本政策的标题仅为方便及阅读而设，不影响本协议任何条款的含义或解释。</p>
    </div>
</template>

<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<style scoped>
h3, h4 {
    color: #5daf34;
}

p, ul {
    text-indent: 33px;
}

ul {
    list-style-type: circle;
}
</style>